import React from 'react'
import { sendMessageOutsideIframe } from 'utils/game.utils'

const LandingLogo = ({ className = '' }) => {
  const goLanding = () => {
    if (window.parent && window.parent !== window) {
      sendMessageOutsideIframe('RETURN_TO_LANDING')
    }
  }

  return (
    <button type='button' className='landing-logo-btn' onClick={goLanding} aria-label='Back to landing'>
      <img src='/assets/v2-logo.png' alt='Gamma Poker' className={className} />
    </button>
  )
}

export default LandingLogo
